<template>
    <v-container fliud>
        <template v-if="!loading">
            <v-row class="mb-1 d-flex justify-space-between align-center">
                <v-col md="auto" align="center" justify="space-between">
                    <v-text-field
                        class="shrink"
                        v-model="firstHalfPrediction"
                        :disabled="isDoorCount"
                        @change="addDoors()"
                        type="number"
                        dense
                        placeholder="# of Doors"
                        outlined
                        :label="'First Half New Doors for ' + category.Forecast_Name"
                        min="0"
                    ></v-text-field><br>
                    <v-card>
                        <v-card-title primary-title class="justify-center">
                            Current Doors
                        </v-card-title>
                        <v-card-text class="text-h5 mb-1" style="text-align:center;vertical-align:middle;">
                            {{ currentDoorCount }}
                        </v-card-text>
                    </v-card>
                </v-col>
                <v-divider vertical></v-divider>
                <v-col md="auto" align="center" justify="space-between">
                    <v-text-field
                        class="shrink"
                        v-model="secondHalfPrediction"
                        :disabled="isDoorCount"
                        @change="addDoors()"
                        type="number"
                        dense
                        placeholder="# of Doors"
                        outlined
                        :label="'Second Half New Doors for ' + category.Forecast_Name"
                        min="0"
                    ></v-text-field><br>
                    <v-card>
                        <v-card-title  primary-title class="justify-center">
                            Total Doors
                        </v-card-title>
                        <v-card-text class="text-h5 mb-1" style="text-align:center;vertical-align:middle;">
                            {{ totalDoorCount }}
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>
            <v-row class="d-flex justify-center align-center">
                <v-btn @click="save()" color="primary">Save</v-btn>
            </v-row>
        </template>
        <template v-else>
            <v-progress-circular indeterminate color="primary"></v-progress-circular>
        </template>
    </v-container>
</template>

<script>

export default {
    name: 'bizDev',
    props: {
        refresh: {type: Boolean},
        category: {type: Object},
        year: {type: Number},
    },
    watch: {
        refresh: function() {
            this.getDoors()
        }
    },
    data: () => ({
        firstHalfPrediction: 0,
        secondHalfPrediction: 0,
        currentDoorCount: 0,
        loading: false,
    }),
    methods: {
        getDoors() {
            const url = 'https://ww62v3jt5m.execute-api.us-east-2.amazonaws.com/prod/accounts/doorcount';
			const data = {
				forecastId: this.$props.category.Forecast_Id,
                year: this.$props.year
			};
			const request = {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
				},
				body: JSON.stringify(data),
			};
            this.loading = true
            fetch(url, request).then(async response => {
                const data = await response.json();
				if (!response.ok) {
					const error = (data && data.message) || response.status
					return Promise.reject(error)
				}

                let firstHalf = 0
				let secondHalf = 0
				if (data.doorPrediction.length == 0) {
					firstHalf = 0
					secondHalf = 0
				} else {
					firstHalf = data.doorPrediction[0].First_Half
					secondHalf = data.doorPrediction[0].Second_Half
				}
                this.firstHalfPrediction = firstHalf
                this.secondHalfPrediction = secondHalf
                this.currentDoorCount = data.doorCount[0].doorCount
                this.loading = false
            })
        },
        save() {
            const url = 'https://ww62v3jt5m.execute-api.us-east-2.amazonaws.com/prod/accounts/doorcount';
			const data = {
				forecastId: this.$props.category.Forecast_Id,
                year: this.$props.year,
                firstHalf: this.firstHalfPrediction,
                secondHalf: this.secondHalfPrediction,
			};
			const request = {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
				},
				body: JSON.stringify(data),
			};
            this.loading = true
            fetch(url, request).then(async response => {
                const data = await response.json();
				if (!response.ok) {
					const error = (data && data.message) || response.status
					return Promise.reject(error)
				}
                this.loading = false
                this.$emit('bizDevSettings', 'refresh')
            })
        },
        addDoors() {
            this.firstHalfPrediction = Number(this.firstHalfPrediction)
            this.secondHalfPrediction = Number(this.secondHalfPrediction)
        },
    },
    computed: {
        totalDoorCount() {
            return Number(this.firstHalfPrediction) + Number(this.secondHalfPrediction) + this.currentDoorCount
        },
        isDoorCount() {
            if (this.currentDoorCount == 0) {
                return true
            } else {
                return false
            }
        },
    }
}
</script>
